import React, { useRef, useState } from 'react';
import Image from 'next/image';
import { StyledWidgetHero } from './widgetHero.styles';
import { IPlatform, IPlugin } from '../../types';
import { useParallax } from 'react-scroll-parallax';
import { CustomLink } from '../link/link.comp';
import { WidgetNavbar } from '../widgetNavbar/widgetNavbar.comp';

interface IWidgetHeroProps {
	widget: IPlugin;
	platform?: IPlatform;
}

export const WidgetHero = ({ widget, platform }: IWidgetHeroProps) => {
	const [formPopupOpen, setFormPopupOpen] = useState(false);
	const mainImageRef = useRef<any>();
	const parallax = useParallax({
		translateY: ['50px', '-45px'],
	});
	const parallax2 = useParallax({
		translateY: ['-50px', '70px'],
	});

	return (
		<>
			<StyledWidgetHero>
				<WidgetNavbar
					setFormPopupOpen={setFormPopupOpen}
					widget={widget}
					platform={platform}
				/>
				<div className="hero-wrapper">
					{platform?.icon && (
						<div className="img-wrapper">
							<Image src={platform.icon} alt={platform.title} fill />
						</div>
					)}
					<h1
						className={`${widget.status === 'coming-soon' ? 'coming-soon' : ''
							} `}
					>
						{widget.name}
						{platform?.title ? ` for ${platform.title}` : ''}
					</h1>
					<h2>{widget.teaser}</h2>
					<CustomLink
						external
						title={`${widget.buttonText} ${platform ? `for ${platform.title}` : ''
							}`}
						className="try-button"
						href={`https://www.commoninja.com/brackets/editor?via=brackets`}
						onClick={() => {
							// trackEvent(`Landing page ${widget.name}${platform ? ' ' + platform.title : ''}`, { serviceName: widget.serviceName });
						}}
					>
						{widget.buttonText}
					</CustomLink>
					<div ref={mainImageRef} className="hero-image">
						<Image
							className="main"
							src={widget.hero}
							alt={`${widget.name}${platform ? ` for ${platform.title}` : ''}`}
							width={930}
							height={524}
							priority
						/>
						<Image
							ref={parallax.ref as any}
							className="right"
							src={'/assets/widget-hero-right.svg'}
							alt={`${widget.name} ${platform ? `for ${platform.title}` : ''
								} settings`}
							width={195}
							height={333}
							priority
						/>
						<Image
							ref={parallax2.ref as any}
							className="left"
							src={'/assets/widget-hero-left.svg'}
							alt={`${widget.name}${platform ? ` for ${platform.title}` : ''
								} design`}
							width={173}
							height={177}
							priority
						/>
						<div className="glass"></div>
						{renderStars()}
						{renderDagger()}
					</div>
				</div>
			</StyledWidgetHero>
		</>
	);
};

function renderStars() {
	return (
		<svg
			className="stars"
			width="131"
			height="91"
			viewBox="0 0 131 91"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M21.7328 78.6868C21.7997 79.615 21.1315 80.4336 20.2089 80.5542L2.23181 82.9005C1.59552 82.9835 0.964595 82.713 0.586374 82.1945C0.208177 81.6759 0.143125 80.9921 0.416501 80.4121L8.13962 64.0098C8.53583 63.1681 9.52004 62.7817 10.3831 63.1289C11.4451 63.5562 12.6295 63.4098 13.5512 62.7372C14.2604 62.2198 14.7257 61.4573 14.8614 60.5899C14.9971 59.7226 14.7867 58.8544 14.2694 58.1452L14.2694 58.145C13.6003 57.2278 12.5222 56.7264 11.3853 56.8041C10.46 56.8673 9.64508 56.1997 9.52491 55.2798L7.16963 37.2329C7.14777 37.0648 7.15057 36.897 7.17599 36.7344C7.24692 36.2809 7.49417 35.8656 7.87583 35.5873C8.39429 35.2091 9.07771 35.144 9.65825 35.4175L26.1242 43.1706C26.9634 43.5657 27.3502 44.5452 27.0076 45.4076C26.5861 46.4666 26.7348 47.6462 27.4039 48.5634C27.9214 49.2726 28.6839 49.738 29.5513 49.8736C30.4187 50.0093 31.2869 49.7989 31.9961 49.2816C32.9179 48.6091 33.4195 47.5264 33.3363 46.3844C33.2698 45.4556 33.9377 44.6375 34.8603 44.5171L52.8374 42.1709C53.4736 42.088 54.1046 42.3585 54.4828 42.8769C54.8608 43.3954 54.9261 44.0788 54.6527 44.6594L46.9294 61.0616C46.5332 61.9033 45.549 62.2897 44.6859 61.9425C43.6239 61.5152 42.4397 61.6616 41.5177 62.3342C40.0541 63.4022 39.7317 65.4621 40.7996 66.9264C41.4688 67.8438 42.547 68.345 43.6837 68.2675C44.609 68.2043 45.4239 68.8719 45.5441 69.7917L47.8995 87.8387C47.9824 88.4755 47.7118 89.106 47.1935 89.4841C46.675 89.8623 45.9916 89.9274 45.4111 89.654L28.9452 81.9007C28.1059 81.5057 27.7185 80.5267 28.0617 79.6637C28.4829 78.6056 28.3345 77.4255 27.6653 76.5077C26.5972 75.0438 24.5373 74.7216 23.0731 75.7897C22.1513 76.4621 21.6498 77.5457 21.7328 78.6868ZM33.3007 63.474C33.058 65.026 32.2255 66.3906 30.9564 67.3164C29.6873 68.2422 28.1337 68.6183 26.5817 68.3756C25.0297 68.1328 23.6652 67.3004 22.7393 66.0313C21.8135 64.7621 21.4375 63.2085 21.6802 61.6566C21.9229 60.1046 22.7554 58.74 24.0245 57.8142C25.2936 56.8884 26.8472 56.5123 28.3992 56.7551C29.9511 56.9978 31.3157 57.8303 32.2415 59.0994C33.1674 60.3685 33.5434 61.9221 33.3007 63.474Z"
				fill="#6278D4"
			/>
			<path
				d="M89.1013 19.7774C88.2627 18.066 90.066 16.2627 91.7774 17.1014L102.463 22.3373C102.695 22.4514 102.948 22.5192 103.207 22.5368L115.078 23.3449C116.98 23.4743 117.64 25.9376 116.058 27.0004L106.181 33.636C105.966 33.7806 105.781 33.9656 105.636 34.1808L99.0003 44.0579C97.9375 45.6399 95.4743 44.9799 95.3448 43.0784L94.5367 31.2068C94.5191 30.9481 94.4514 30.6954 94.3373 30.4626L89.1013 19.7774Z"
				fill="#6278D4"
			/>
		</svg>
	);
}

function renderDagger() {
	return (
		<svg
			className="dagger"
			width="82"
			height="85"
			viewBox="0 0 82 85"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M38.4337 30.2213L36.0807 43.6142C36.0289 43.9094 36.1466 44.2088 36.3859 44.3897L71.2929 70.719C71.9255 71.1962 72.7915 70.5599 72.5251 69.8136L57.8283 28.6343C57.7276 28.3519 57.477 28.1498 57.1798 28.1111L44.016 26.3966L34.2423 13.095L34.2279 13.1056C35.705 10.4338 35.598 7.03077 33.675 4.41359C31.0406 0.828373 25.9804 0.0547336 22.3952 2.68907C18.8099 5.32374 18.0363 10.3837 20.6706 13.9689C22.5936 16.5859 25.8091 17.705 28.8 17.0939L28.7922 17.0996L38.4337 30.2213ZM29.5877 12.4778C31.3997 11.1464 31.7908 8.58868 30.4593 6.77666C29.1279 4.96463 26.5702 4.5736 24.7582 5.90504C22.9461 7.23647 22.5551 9.79416 23.8865 11.6062C25.218 13.4182 27.7757 13.8092 29.5877 12.4778Z"
				fill="#FAFAFC"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M17.8253 62.4492L21.4481 68.6078C21.5279 68.7435 21.677 68.8232 21.8344 68.814L44.7653 67.45C45.1808 67.4253 45.3104 66.8757 44.9496 66.668L25.0414 55.2072C24.9049 55.1286 24.7358 55.1332 24.6037 55.2189L18.756 59.018L10.3148 57.0285L10.3127 57.0375C9.99306 55.4658 8.79078 54.1413 7.12999 53.7499C4.85491 53.2137 2.56763 54.6284 2.03142 56.9035C1.49529 59.1787 2.90994 61.4658 5.18502 62.0021C6.84572 62.3935 8.51297 61.7454 9.50086 60.482L9.49969 60.4869L17.8253 62.4492ZM8.24308 58.3675C8.51409 57.2177 7.79901 56.0616 6.64915 55.7905C5.49929 55.5195 4.34319 56.2346 4.07218 57.3845C3.80116 58.5343 4.51624 59.6904 5.6661 59.9614C6.81596 60.2325 7.97207 59.5174 8.24308 58.3675Z"
				fill="#FAFAFC"
			/>
		</svg>
	);
}
